var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7346 10.8138L19.4946 14.3338C19.7346 14.8138 20.3746 15.2938 20.9079 15.3738L24.0946 15.9071C26.1346 16.2538 26.6146 17.7205 25.1479 19.1871L22.6679 21.6671C22.2546 22.0805 22.0146 22.8938 22.1479 23.4805L22.8546 26.5605C23.4146 28.9871 22.1213 29.9338 19.9746 28.6671L16.9879 26.8938C16.4412 26.5738 15.5613 26.5738 15.0146 26.8938L12.0279 28.6671C9.88124 29.9338 8.5879 28.9871 9.1479 26.5605L9.85461 23.4805C9.98794 22.9071 9.74792 22.0938 9.33459 21.6671L6.85461 19.1871C5.38794 17.7205 5.86791 16.2404 7.90791 15.9071L11.0946 15.3738C11.6279 15.2805 12.2679 14.8138 12.5079 14.3338L14.2679 10.8138C15.2146 8.90712 16.7879 8.90712 17.7346 10.8138Z",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.0003V2.66699",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0003V2.66699",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.33366V2.66699",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.b8fa85c350bf505846ddd0d5a86f5a2f.svg";
export { ForwardRef as ReactComponent };